export type SlotCategory = 'Core' | 'AI Tools' | 'Frontend' | 'Git' | 'Visualization' | 'Testing';
export const SLOTS: SlotCategory[] = ['Core', 'AI Tools', 'Frontend', 'Git', 'Visualization', 'Testing'];

export const CHROME_VIEW_IDS = ['home', 'features-list'] as const;
